const fish_image = "https://files.arshiyaniha.com/payments/";

export { fish_image };
